export type RouteHandler = () => HTMLElement;

interface Router {
  register(hash: string, handler: RouteHandler): void;
  start(): void;
  navigate(hash: string): void;
  getCurrentRoute(): string;
}

export function createRouter(container: HTMLElement): Router {
  const routes = new Map<string, RouteHandler>();

  function render() {
    const fullHash = location.hash.slice(1) || 'home';
    const hash = fullHash.split('?')[0];
    // Old bookmarks (#dashboard, #budget, …) land on Home.
    const handler = routes.get(hash) ?? routes.get('home');
    container.innerHTML = '';
    if (handler) {
      container.appendChild(handler());
    }
    window.dispatchEvent(new CustomEvent('routechange', { detail: { route: hash } }));
  }

  return {
    register(hash, handler) {
      routes.set(hash, handler);
    },
    start() {
      window.addEventListener('hashchange', render);
      render();
    },
    navigate(hash) {
      location.hash = '#' + hash;
    },
    getCurrentRoute() {
      return location.hash.slice(1) || 'home';
    },
  };
}
